import L from "leaflet";
import { onUnmounted, computed, watch } from "vue";
import { useStore } from "vuex";

export default function useMiniMap() {
  const store = useStore();
  let miniMap;
  let rect;
  const switchMiniMap = computed(
    () => store.state.exportStore.formData.switchMiniMap
  );

  function getMapBounds() {
    const { mainMap } = store.state.exportStore.mapData;
    const mainMapBounds = mainMap.getBounds();
    const ne = mainMapBounds.getNorthEast();
    const sw = mainMapBounds.getSouthWest();
    return [
      [ne.lat, ne.lng],
      [sw.lat, sw.lng],
    ];
  }

  function cleanMiniMap() {
    if (miniMap) {
      const { mainMap } = store.state.exportStore.mapData;
      miniMap.remove();
      miniMap = null;
      mainMap.off("move", handleMapMove);
    }
  }

  function handleMapMove() {
    // const { mainMap } = store.state.exportStore.mapData;
    // miniMap.setView(mainMap.getCenter(), Math.max(mainMap.getZoom() - 3, 1));
    const bounds = getMapBounds();
    rect.setBounds(bounds);
    miniMap.fitBounds(bounds,{padding:[20,20]});
  }

  function addMiniMap() {
    const { mainMap } = store.state.exportStore.mapData;

    miniMap = L.map("mini-map", {
      zoom: 1,
      attributionControl: false,
      zoomControl: false,
      minZoom:-1
    }).setView([39.9042, 116.4074]);

    L.tileLayer(
      process.env.VUE_APP_BASEMAP_XIANHUA,
      {
        maxZoom: 17,
        subdomains: ['1', '2', '3'],
      }
    ).addTo(miniMap);

    const imageUrl = process.env.VUE_APP_BASEMAP_XIANHUA.replace(/\{s\}/g, "1").replace(/\{x\}|\{y\}|\{z\}/g, "0"),
    imageBounds = [[-85.05112877980659,180],[85.05112877980659,-180]];
    const minMapImageLayer = L.imageOverlay(imageUrl, imageBounds).addTo(miniMap);
    miniMap.on('zoom',()=>{
      if(miniMap.getZoom()>1){
        minMapImageLayer.remove();
      }else{
        minMapImageLayer.addTo(miniMap);
      }
    });

    rect = L.rectangle(getMapBounds(), { color: "red", weight: 2 }).addTo(
      miniMap
    );
    mainMap.on("move", handleMapMove);
    handleMapMove();
  }

  function initMiniMap() {
    watch(switchMiniMap, (newVal) => {
      if (newVal) {
        setTimeout(() => {
          addMiniMap();
        }, 0);
      } else {
        cleanMiniMap();
      }
    });
    if (switchMiniMap.value) {
      addMiniMap();
    }
  }

  onUnmounted(cleanMiniMap);

  return {
    initMiniMap,
  };
}
